import React from 'react';
import { object, string, func, number, array, bool } from 'prop-types';
import styled from 'styled-components';
import Wrapper from '../Wrapper';
import Tag from '../Tag';
import HotelGenericImage from '../Image/HotelGenericImage';
import Image from '../Image';
import ImageCarousel from '../ImageCarousel/components/Slider';
import useWindowSize from '../../utils/windowSize';
import Icon from '../Icon';

const ImageCount = styled(Wrapper)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 34px;
  flex-direction: row;
  background: ${({ theme }) => theme.colors.darkBlack};
  border-radius: 50px;
  width: 77px;
  position: absolute;
  z-index: 0;
  top: 8px;
  color: ${({ theme }) => theme.colors.primaryWhite};
  font-size: 12px;
  line-height: 18px;
  right: 8px;
  cursor: pointer;
`;

const CollectionsIcon = styled(Icon)`
  margin-right: 4px;
  color: ${({ theme }) => theme.colors.primaryWhite};
`;

const CardThumbnail = ({
  image,
  images,
  onLoadImage,
  leftPillText,
  leftPillType,
  rightPillText,
  thumbnailStyle = {},
  isShowCarousel,
  isHotel,
  imageCount,
  onRoomImageClickHandler,
  override,
}) => {
  const ImageComponent = (
    <>
      <Image
        src={image}
        onLoad={onLoadImage}
        fallbackContent={<HotelGenericImage />}
      />
      {imageCount && imageCount > 1 && (
        <ImageCount
          onClick={onRoomImageClickHandler && onRoomImageClickHandler}
        >
          <CollectionsIcon icon="CollectionsIcon" fontsize="titleSmall" /> +{' '}
          {imageCount - 1}
        </ImageCount>
      )}
    </>
  );

  const ImageCarouselComponent = (
    <ImageCarousel
      responsive={[
        { breakPoint: 1280, cardsToShow: 1 },
        { breakPoint: 760, cardsToShow: 1 },
      ]}
      autoSlide={false}
      infinite={true}
      cardsToShow={1}
      isHotel={isHotel}
    >
      {Array.isArray(images) &&
        images.length > 0 &&
        images.map((image, index) => {
          return (
            <Image
              key={index}
              src={image}
              onLoad={onLoadImage}
              fallbackContent={<HotelGenericImage />}
            />
          );
        })}
    </ImageCarousel>
  );

  const { isMobileView } = useWindowSize();
  const getTextColor = () => {
    return override
      ? isMobileView
        ? '#ffffff'
        : '#212124'
      : leftPillType === 2
      ? 'primaryWhite'
      : 'darkBlack';
  };

  return (
    <Wrapper
      className="hotel-image"
      borderRadius={
        isHotel ? ['4px 4px 0 0', '4px 0 0 4px'] : ['4px 4px 0 0', 4]
      }
      overflow="hidden"
      position="relative"
      height={isHotel ? [128, 212] : [128, 180]}
      width={isHotel ? ['100%', 224] : override ? '100%' : ['100%', 208]}
      {...thumbnailStyle}
    >
      <Wrapper width="100%" height="100%">
        {isShowCarousel && Array.isArray(images) && images.length > 0 ? (
          ImageCarouselComponent
        ) : image ? (
          ImageComponent
        ) : (
          <HotelGenericImage />
        )}
      </Wrapper>
      {leftPillText && (
        <Tag
          override={override}
          backgroundColor={leftPillType === 2 ? 'secondary' : 'primaryWhite'}
          wrapperStyles={{
            position: 'absolute',
            left: 0,
            top: 0,
            margin: leftPillType === 2 ? 0 : 3,
            marginTop: 3,
            className: 'left-pill-text',
          }}
          textStyles={{
            color: getTextColor(),
          }}
          type={leftPillType}
        >
          {leftPillText}
        </Tag>
      )}
      {rightPillText && (
        <Tag
          wrapperStyles={{
            position: 'absolute',
            alignSelf: 'flex-end',
            bottom: 0,
            right: 0,
            margin: 3,
            className: 'right-pill-text',
          }}
        >
          {rightPillText}
        </Tag>
      )}
    </Wrapper>
  );
};

CardThumbnail.propTypes = {
  image: string,
  images: array,
  onLoadImage: func,
  leftPillText: string,
  leftPillType: number,
  rightPillText: string,
  theme: object,
  thumbnailStyle: object,
  isShowCarousel: bool,
  isHotel: bool,
  imageCount: number,
  onRoomImageClickHandler: func,
  override: bool,
};

export default CardThumbnail;
